export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Generic retry wrapper with exponential backoff
 * @param {Function} operation - The async operation to retry
 * @param {Object} options - Configuration options
 * @param {Function} options.shouldRetry - Function that returns true if error should trigger retry
 * @param {number} options.maxRetries - Maximum number of retries (default: 3)
 * @param {number} options.attempt - Current attempt number (internal use)
 * @returns {Promise} Promise that resolves to the operation result
 */
export const withRetry = async (operation, options = {}) => {
  const {
    shouldRetry = error => error.status >= 500,
    maxRetries = 3,
    attempt = 0
  } = options;

  try {
    return await operation(attempt);
  } catch (error) {
    if (shouldRetry(error) && attempt < maxRetries) {
      const delayTime = Math.pow(2, attempt + 1) * 1000; // 2, 4, 8 seconds
      await delay(delayTime);
      return withRetry(operation, {
        shouldRetry,
        maxRetries,
        attempt: attempt + 1
      });
    }
    throw error;
  }
};

export const createError = (
  message,
  status,
  statusText,
  requestText,
  errorOrigin
) => {
  const error = new Error(message);
  error.name = 'Request error';
  error.status = status;
  error.statusText = statusText;
  error.requestText = requestText;
  if (errorOrigin) error.errorOrigin = errorOrigin;
  return error;
};
